import { ApiService } from "../..";

export const getSampleGroupDetail = (id: string) => {
  return ApiService.baseAction("sample-group/" + id, {}, "get");
};
